import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Skill } from '../types';

interface SkillCardProps {
  skill: Skill;
}

const SkillCard = ({ skill }: SkillCardProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative bg-surface rounded-lg p-6 border border-border hover:border-primary/50 transition-all duration-300 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className="w-12 h-12 rounded-lg flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
            style={{ backgroundColor: `${skill.color}20` }}
          >
            <Icon name={skill.icon} size={24} color={skill.color} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{skill.name}</h3>
            <p className="text-sm text-muted-foreground">{skill.category}</p>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-primary">{skill.proficiency}%</div>
          <div className="text-xs text-muted-foreground">{skill.yearsOfExperience} years</div>
        </div>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Proficiency</span>
          <span className="text-sm font-medium text-foreground">{skill.proficiency}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-1000 ease-out"
            style={{
              width: isHovered ? `${skill.proficiency}%` : '0%',
              backgroundColor: skill.color,
            }}
          />
        </div>
      </div>

      <p className="text-sm text-muted-foreground mb-4">{skill.description}</p>

      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="FolderGit2" size={16} />
          <span>{skill.projects} projects</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-primary">
          <Icon name="TrendingUp" size={16} />
          <span>Active</span>
        </div>
      </div>
    </div>
  );
};

export default SkillCard;